import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import {
	setModoTela, initForm
} from './preIncubacaoValidacaoActions';
import {
	setModoTela as setModoTelaTrilaConhecimento
} from '../trilhaConhecimento/trilhaConhecimentoActions';
import consts from '../consts';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler';
import TextoInput from '../texto/textoInput';

class PreIncubacaoValidacaoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'
					style={{ padding: 0 }}>
					<ContentCard style={{
						marginTop: 20,
						backgroundColor: '#0F2748',
						color: '#ffffff',
						borderRadius: 20,
						boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
						opacity: '80%'
					}}>
						<ContentCardHeader
							style={{
								marginTop: 16,
								marginBottom: 16
							}}>
							<label>{this.props.preIncubacaoValidacaoFormTitulo}</label>

							{!this.props.modoAdm &&
							<TextoInput chave='preIncubacaoValidacaoFormTitulo' />}
						</ContentCardHeader>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>
								
									<Field
										name='nome_projeto'
										component={LabelAndInput}
										label='Nome do Projeto: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='descricao'
										component={LabelAndTextarea}
										label='Descrição: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									 
																		
									{!this.props.excluir &&
									<Grid cols='12 12 12 12'
										style={{
											marginBottom: 12
										}}>

										<p>Anexar o canva do modelo de negócio:</p>

										{(this.props.formularioValues.anexos || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', padding: 10 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img src={arquivo.arquivo_base64 || `${consts.URL}/${arquivo.arquivo}`} style={{ minWidth: 200, width: 'auto', height: 'auto', maxHeight: 300, maxWidth: '70%' }} />
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-primary'
														style={{ width: '48%' }}
														disabled={arquivo.arquivo_base64 ? true : false}
														onClick={() => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>
													<button
														type='button'
														class='btn btn-flat btn-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																anexos: this.props.formularioValues.anexos.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										
										<ClipboardImageHandler
											label='Use Ctrl+V para colar ou arraste e solte anexos aqui.'
											msgErro='Selecione apenas (.PNG, .JPG e .JPEG)'
											types={[
												'image/png',
												'image/jpg',
												'image/jpeg'
											]}
											onChange={result => {

												let lista = (this.props.formularioValues.anexos || []).map(item => item);
												lista.push({
													arquivo_base64: result
												});
												this.props.initForm({
													...this.props.formularioValues,
													anexos: lista
												});
											}} />
									</Grid>}
									
										
								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									{!this.props.modoAdm ? (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
										</Grid>
									) : (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => this.props.setModoTelaTrilaConhecimento('trilha')} />
										</Grid>
									)}
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

PreIncubacaoValidacaoForm = reduxForm({form: 'preIncubacaoValidacaoForm', destroyOnUnmount: false})(PreIncubacaoValidacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('preIncubacaoValidacaoForm')(state),
	registro: state.preIncubacaoValidacao.registro,
	lista: state.preIncubacaoValidacao.lista,
	preIncubacaoValidacaoFormTitulo: state.texto.lista.filter(item => item.chave == 'preIncubacaoValidacaoFormTitulo').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, 
	setModoTelaTrilaConhecimento
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PreIncubacaoValidacaoForm);
